import { useTheme, paletteColors, Box } from '@evaneos/b2b-ui';
import { ReactNode } from 'react';

export function ActiveCallWidgetWrapper({ children }: { children: ReactNode }) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.grey[900],
                color: paletteColors.neutral[0],
                borderRadius: 2,
                boxShadow: 8,
                transition: 'background-color 200ms, color 200ms',
                height: { xs: 110, sm: 78 },
                padding: 2,
                position: 'relative',
                zIndex: theme.zIndex.modal,
            }}
            data-testid="active-call-widget-wrapper"
        >
            {children}
        </Box>
    );
}
